/**
 * Created by Administrador on 20/11/2017.
 */
(function(){
    'use strict';
    angular
        .module('completeAir')
        .controller('urgentCtrl', urgentCtrl)
        .controller('newEditUrgentCtrl', newEditUrgentCtrl)
        .controller('deleteUrgentCtrl', deleteUrgentCtrl);

    urgentCtrl.$inject = ['linkService', 'urgents'];

    newEditUrgentCtrl.$inject = ['urgentService', 'linkService', 'urgent','action'];

    deleteUrgentCtrl.$inject = ['urgent', 'urgentService', '$uibModalInstance','linkService'];

    function urgentCtrl(linkService, urgents){
        var vm = this;

        vm.urgents = (urgents.data._embedded) ? urgents.data._embedded.urgents : [];
        vm.linkService = linkService;
    }

    function newEditUrgentCtrl(urgentService, linkService, urgent, action){
        var vm = this;
        vm.linkService = linkService;
        vm.urgent = {};

        if(action == 'edit'){
            vm.urgent.lang = urgent.data.lang;
            vm.urgent.priority = urgent.data.priority;
            vm.urgent.urgentId = vm.linkService.getLinkId(urgent.data._links.self.href);
        }

        vm.save = function(isValid, urgent){
            if (isValid) {
                urgent.active = true;
                urgent.baseTariff = false;
                if(action == "new"){
                    urgentService.saveUrgent(urgent);
                }else{
                    urgentService.updateUrgent(vm.urgent.urgentId, vm.urgent)
                }
            }
        }
    }

    function deleteUrgentCtrl(urgent, urgentService, $uibModalInstance,linkService){
        var vm = this;
        vm.urgent = urgent.data;

        vm.delete = function(){
            urgentService.deleteUrgent(linkService.getLinkId(urgent.data._links.self.href))
                .then(function(){
                    $uibModalInstance.close(true);
                })
        }

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }
})();
